var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts,"sort-by":['calories', 'fat'],"sort-desc":[false, true],"multi-sort":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }